var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-6",attrs:{"id":"add-one","fab":"","elevation":0},on:{"click":function($event){return _vm.$emit('add')}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" fa-plus ")])],1)]}}])},[_c('span',[_vm._v("Add One")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }